import React, { useState, useEffect } from 'react'
import Table from 'react-bootstrap/Table'
import { v4 as uuidv4 } from 'uuid';
import { onlyNumberWithDecimal } from '../../components/functions'
import api from '../api';
import { Link } from 'react-router-dom'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { useAmbienteContext } from '../../context/ambienteContext'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'


import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../StatusValidacaoSecao';

//import $ from 'jquery'


const Ambiente = (props) => {

    
    var { energiaAmbiente_id, setEnergiaAmbiente_id } = useAmbienteContext()

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var energia_id = props.energia_id
    
    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()


    
    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao, setQuestao] = useState()
    const [totalPendencias, setTotalPendencias] = useState(0)


    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Ambientes':

                                totalErros = totalErros + 1
                                setQuestao('red')
    
                            break

                            
                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    var [resultado, setResultado] = useState()


    //var [energiaAmbiente_id, setEnergiaAmbiente_id] = useState()
    

    

    function carregaAmbientes() {
        
        
        if (energia_id) {

            api.get(`energiaAmbienteLista/${energia_id}`).then((result) => {

                //console.log(result.data)

                setResultado(result.data.map((rs) =>


                <tr key={rs.energiaAmbiente_id} style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalAmbiente').modal('show');setEnergiaAmbiente_id(rs.energiaAmbiente_id)}}>
                    <td>
                        {rs.identificacao}
                    </td>
                    <td>
                        {rs.tipoClimatizacao}
                    </td>
                    <td>
                        {rs.area}
                    </td>
                    <td>
                        {rs.horasDia}
                    </td>
                    <td>
                        {rs.tipoLampadaDescri}
                    </td>
                    <td>
                        {rs.tipoSistemaDescri}
                    </td>
                    
                </tr>
                
                ))
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        
    }



    useEffect(() => {

        //console.log(energia_id, '!?')

        setResultado()
        carregaAmbientes()

    }, [ano, atualizacaoGestao, energia_id])






    return (

        <div>

            <div className="col-md-12">
                <div align="left">
                
                    <Link to='#' style={{ color: questao }} onClick={() => {setEnunciado('Ambientes');setSecaoEnunciado('Ambientes');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                
                    
                    <button type="button" className="btn btn-success" onClick={() => {window.$('#modalAmbiente').modal('show');setEnergiaAmbiente_id()}}  >+ Adicionar</button>&nbsp;
                    <button type="button" className="btn btn-info" onClick={() => {window.$('#modalAmbienteResumo').modal('show')}}  >Resumo</button>
                    <br/><br/>

                </div>
            </div>


                <div className="col-md-12">


                    <Table striped bordered hover>

                        <thead>
                            <tr>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Identificação

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Tipo de Climatização *

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Área [m<sup>2</sup>] *

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Horas/dia *

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Tipo de lâmpada

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    TIpo de Sistema de Climatização

                                </th>
                               
                            </tr>

                        </thead>
                        
                        <tbody>
                            {resultado}
                            <tr style={{ display: 'none' }}>
                                
                                
                                <td>
                                    
                                     
                                </td>
                                
                            </tr>


                        </tbody>

                    </Table>


                </div>

                


                <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoAmbientes" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Ambientes" ano={ano} />
                

        </div>

        

    )

}

export default Ambiente